import Search from './Search';
import { Link } from 'react-router-dom';
import {useSelector} from 'react-redux';

const SidebarMini = () => {
  const { showSidebar } = useSelector(state => state.sidebar)
  
  return (
    <>
      <section
        className={`
          lg:hidden
          fixed
          min-h-full
          right-0
          text-xl
          text-right
          w-full
          justify-end
          bg-gray-900
          bg-opacity-80
          text-gray-50
          divide-y
          divide-gray-200
          transform
          duration-300
          ease-in-out
          z-50
          mt-20
          ${!showSidebar && '-translate-x-full'}`}
      >
        <div>
            <button
              className="
                p-2
                mr-4
                my-3
                mx-2
                rounded-lg
                hover:bg-gray-200
                hover:text-gray-900"
          >
            <Link to="/">
              Home
            </Link>
          </button>
        </div>
        <div>
            <button
              className="
                p-2
                mr-4
                my-3
                mx-2
                rounded-lg
                hover:bg-gray-200
                hover:text-gray-900"
            >
              <Link to="/mydeck">
                My Deck
              </Link>
            </button>
        </div>
        <Search />
      </section>
    </>
  )
}

export default SidebarMini
